import { useParams } from 'react-router-dom'

import { RouteParams } from '@/routes/routes'

export default function useInvoiceId() {
  const { invoiceId } = useParams<RouteParams['INVOICE']>()
  return invoiceId
}
